import { getOrganizationSlug } from "auth/helpers/authApi";
import { ROOT_SLUG } from "constants/index";
import { useParams } from "react-router-dom";

const getStoryParam = () => {
	const excludePaths = ["reset-password", "dashboard"];
	const splitPath = window.location.pathname.split("/")[2];
	if (!excludePaths.includes(splitPath)) {
		return splitPath;
	}
	return undefined;
};

export const useSlugParams = () => {
	const localStoreOrgSlug = getOrganizationSlug();
	const { slug } = useParams();
	const userBasedSlug = slug ? slug : localStoreOrgSlug || ROOT_SLUG;

	return userBasedSlug;
};

export const useStoryParams = () => {
	let { story } = useParams<{ story: string }>();
	story = story?.trim().toLowerCase() || getStoryParam();
	return story;
};
